import React, { Component } from 'react'
import { Menu } from 'semantic-ui-react'
import { GoogleLogin, GoogleLogout } from 'react-google-login'
export default class MenuNav extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.onChange = props.onChange || (() => {})
  }

  handleItemClick = (e, { name }) => {
    this.setState({ activeItem: name })
    this.onChange(name)
  }

  googleSuccess = (googleUser) => {
    const profile = googleUser.getBasicProfile()
    const { id_token } = googleUser.getAuthResponse()
    console.log('ID: ' + profile.getId()) // Do not send to your backend! Use an ID token instead.
    console.log('Name: ' + profile.getName())
    console.log('Image URL: ' + profile.getImageUrl())
    console.log('Email: ' + profile.getEmail()) // This is null if the 'email' scope is not present.
    console.log('TOKEN: ' + id_token)
  }

  googleFailure = ({ error, details }) =>
    console.error('failure', error, details)

  googleLogout = (msg) => console.log(msg)

  render() {
    const { activeItem } = this.state

    return (
      <Menu>
        <Menu.Item header href="/">
          devtanc's portfolio
        </Menu.Item>
        <Menu.Menu position="right">
          <Menu.Item
            name="home"
            active={activeItem === 'home'}
            onClick={this.handleItemClick}
          />
          <Menu.Item
            name="terrainGenerator"
            active={activeItem === 'terrainGenerator'}
            onClick={this.handleItemClick}
          />
          <Menu.Item
            name="webAudio"
            active={activeItem === 'webAudio'}
            onClick={this.handleItemClick}
          />
          <Menu.Item
            name="ballPhysics"
            active={activeItem === 'ballPhysics'}
            onClick={this.handleItemClick}
          />
          <Menu.Item
            name="mazeGenerator"
            active={activeItem === 'mazeGenerator'}
            onClick={this.handleItemClick}
          />
          {/* <Menu.Item
            name="aboutMe"
            active={activeItem === 'aboutMe'}
            onClick={this.handleItemClick}
          /> */}
          <Menu.Item
            name="contactMe"
            active={activeItem === 'contactMe'}
            onClick={this.handleItemClick}
          />
          <Menu.Item header href="/">
            <GoogleLogin
              clientId="388702466587-78dq6brjtsndl3qhbudqp5rhoqorpcnh.apps.googleusercontent.com"
              buttonText="Login with Google"
              onSuccess={this.googleSuccess}
              onFailure={this.googleFailure}
            />
            <GoogleLogout
              buttonText="Logout"
              onLogoutSuccess={this.googleLogout}
            />
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    )
  }
}
